/* VCTparts: dag-bewuste verzendbelofte ("vandaag / morgen / maandag verzonden").
   Shopify cachet de HTML, dus de server zet een neutrale tekst neer
   ("Werkdagen voor 20:00 besteld, zelfde dag verzonden") en dit script vult in
   de browser de juiste dag in, in de tijdzone van de winkel (Europe/Amsterdam),
   los van de klok of tijdzone van de bezoeker.
   - ma t/m vr voor de sluittijd      -> vandaag verzonden
   - ma t/m do na de sluittijd        -> morgen verzonden
   - vr na de sluittijd, za, zo       -> maandag verzonden
   Elementen: [data-vct-verzenddag="kort|top"] met optioneel data-cutoff="20"
   (uur uit settings.shipping_timer_show_until). Geladen in sections/header.liquid.
   Feestdagen: status() neemt ze niet mee. bezorgdatum() wel (settings.vct_holidays,
   doorgegeven door de aanroeper).
   bezorgdatum(land, sluituur, opties): concrete bezorgdatum voor NL/BE/DE =
   verzenddag (ma–vr, geen feestdag, voor de sluittijd = vandaag) + transittijd in
   bezorgwerkdagen (ma–vr; zaterdag alleen NL als opties.zaterdag). Geeft
   { iso, datum, dagen, verzendIso, vandaag } of null (onbekend land). */
(function () {
  if (window.vctVerzenddag) return;

  var TZ = 'Europe/Amsterdam';
  var DAGEN = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  // Teksten per taal; %{t} = sluittijd. "top" is de topbalk (met nadruk), "kort" de rest.
  var T = {
    nl: {
      kort: { today: 'Voor %{t} besteld, vandaag verzonden', tomorrow: 'Nu besteld, morgen verzonden', monday: 'Nu besteld, maandag verzonden' },
      top: { today: 'Voor <strong>%{t}</strong> besteld, <strong>vandaag verzonden</strong>', tomorrow: 'Nu besteld, <strong>morgen verzonden</strong>', monday: 'Nu besteld, <strong>maandag verzonden</strong>' }
    },
    de: {
      kort: { today: 'Vor %{t} bestellt, heute versandt', tomorrow: 'Jetzt bestellt, morgen versandt', monday: 'Jetzt bestellt, Montag versandt' },
      top: { today: 'Vor <strong>%{t}</strong> bestellt, <strong>heute versandt</strong>', tomorrow: 'Jetzt bestellt, <strong>morgen versandt</strong>', monday: 'Jetzt bestellt, <strong>Montag versandt</strong>' }
    },
    fr: {
      kort: { today: 'Commandé avant %{t}, expédié aujourd’hui', tomorrow: 'Commandé maintenant, expédié demain', monday: 'Commandé maintenant, expédié lundi' },
      top: { today: 'Commandé avant <strong>%{t}</strong>, <strong>expédié aujourd’hui</strong>', tomorrow: 'Commandé maintenant, <strong>expédié demain</strong>', monday: 'Commandé maintenant, <strong>expédié lundi</strong>' }
    },
    en: {
      kort: { today: 'Order before %{t}, shipped today', tomorrow: 'Order now, shipped tomorrow', monday: 'Order now, shipped Monday' },
      top: { today: 'Order before <strong>%{t}</strong>, <strong>shipped today</strong>', tomorrow: 'Order now, <strong>shipped tomorrow</strong>', monday: 'Order now, <strong>shipped Monday</strong>' }
    }
  };

  // Dag (0 = zondag) en uur in Amsterdam
  function nuInAmsterdam() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, weekday: 'short', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
      var dag = null, uur = null;
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'weekday') dag = DAGEN[parts[i].value];
        if (parts[i].type === 'hour') uur = parseInt(parts[i].value, 10) % 24;
      }
      if (dag != null && uur != null && !isNaN(uur)) return { dag: dag, uur: uur };
    } catch (e) {}
    var d = new Date();
    return { dag: d.getDay(), uur: d.getHours() };
  }

  // 'today' | 'tomorrow' | 'monday'
  function status(cutoff) {
    var c = isNaN(cutoff) ? 20 : cutoff;
    var nu = nuInAmsterdam();
    if (nu.dag >= 1 && nu.dag <= 5 && nu.uur < c) return 'today';
    if (nu.dag >= 1 && nu.dag <= 4) return 'tomorrow';
    return 'monday';
  }

  // Datum (jaar, maand, dag, weekdag, uur als kommagetal) in Amsterdam
  function datumInAmsterdam(nu) {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(nu);
      var v = {};
      for (var i = 0; i < parts.length; i++) v[parts[i].type] = parseInt(parts[i].value, 10);
      if (v.year && v.month && v.day) return { y: v.year, m: v.month, d: v.day, uur: (v.hour % 24) + (v.minute || 0) / 60 };
    } catch (e) {}
    return { y: nu.getFullYear(), m: nu.getMonth() + 1, d: nu.getDate(), uur: nu.getHours() + nu.getMinutes() / 60 };
  }

  var TRANSIT = { NL: 1, BE: 1, DE: 2 };
  function isoVan(dt) { return dt.toISOString().slice(0, 10); }

  // land: 'NL' | 'BE' | 'DE'; sluituur: 20 (of 20.5 voor 20:30)
  // opties: { transit, zaterdag, feestdagen ('2026-12-25,...' of array), nu (Date, voor tests) }
  function bezorgdatum(land, sluituur, opties) {
    var o = opties || {};
    var c = String(land || '').toUpperCase();
    if (!TRANSIT.hasOwnProperty(c)) return null;
    var transit = parseInt(o.transit, 10);
    if (isNaN(transit) || transit < 0) transit = TRANSIT[c];
    var cutoff = parseFloat(sluituur);
    if (isNaN(cutoff)) cutoff = 20;
    var lijst = o.feestdagen || [];
    if (typeof lijst === 'string') lijst = lijst.split(',');
    var vrij = {};
    for (var i = 0; i < lijst.length; i++) { var f = String(lijst[i]).trim(); if (f) vrij[f] = true; }
    var zaterdag = !!o.zaterdag && c === 'NL';

    var nu = datumInAmsterdam(o.nu instanceof Date ? o.nu : new Date());
    var start = new Date(Date.UTC(nu.y, nu.m - 1, nu.d, 12));   // kalenderdag, 12:00 UTC
    function verzendbaar(dt) { var w = dt.getUTCDay(); return w >= 1 && w <= 5 && !vrij[isoVan(dt)]; }
    function bezorgbaar(dt) { var w = dt.getUTCDay(); return ((w >= 1 && w <= 5) || (zaterdag && w === 6)) && !vrij[isoVan(dt)]; }
    function volgende(dt) { return new Date(dt.getTime() + 864e5); }

    var verzend = start;
    var vandaag = verzendbaar(start) && nu.uur < cutoff;
    if (!vandaag) { verzend = volgende(start); while (!verzendbaar(verzend)) verzend = volgende(verzend); }
    var bezorg = verzend;
    for (var n = transit; n > 0;) { bezorg = volgende(bezorg); if (bezorgbaar(bezorg)) n--; }
    return {
      iso: isoVan(bezorg),
      datum: bezorg,
      dagen: Math.round((bezorg - start) / 864e5),   // 0 = vandaag, 1 = morgen
      verzendIso: isoVan(verzend),
      vandaag: vandaag
    };
  }

  // "dinsdag 21 oktober" / "Dienstag, 21. Oktober" / "mardi 21 octobre"
  var LOCALES = { nl: 'nl-NL', de: 'de-DE', fr: 'fr-FR', en: 'en-GB' };
  function datumTekst(datum, lang) {
    var l = LOCALES[lang] || LOCALES.nl;
    try { return new Intl.DateTimeFormat(l, { timeZone: TZ, weekday: 'long', day: 'numeric', month: 'long' }).format(datum); }
    catch (e) { return isoVan(datum); }
  }

  function taal(el) {
    var host = el.closest && el.closest('[lang]');
    var l = ((host && host.getAttribute('lang')) || document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
    return T[l] ? l : 'nl';
  }

  function tijd(cutoff, lang) {
    return lang === 'fr' ? cutoff + 'h' : (cutoff < 10 ? '0' : '') + cutoff + ':00';
  }

  function apply(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-vct-verzenddag]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '20', 10);
      var st = status(cutoff);
      var lang = taal(el);
      var key = st + '|' + lang;
      if (el.getAttribute('data-vct-state') === key) continue;
      var soort = el.getAttribute('data-vct-verzenddag') === 'top' ? 'top' : 'kort';
      var tekst = T[lang][soort][st].replace('%{t}', tijd(isNaN(cutoff) ? 20 : cutoff, lang));
      if (soort === 'top') el.innerHTML = tekst; else el.textContent = tekst;
      el.setAttribute('data-vct-state', key);
    }
  }

  window.vctVerzenddag = { status: status, apply: apply, bezorgdatum: bezorgdatum, datumTekst: datumTekst };

  function start() {
    apply(document);
    // Kaarten die later binnenkomen (filters, "meer producten", aanbevelingen, zoeken)
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; apply(document); });
    }).observe(document.body, { childList: true, subtree: true });
    // Om 20:00 of middernacht omschakelen zonder herladen
    setInterval(function () { apply(document); }, 60000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
